export default "__VITE_ASSET__DUdPYNB5__"